/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Source_ApiInputs */

const cs_pm_source_api = /** @type {(inputs: Pm_Source_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API`)
};

const en_pm_source_api = /** @type {(inputs: Pm_Source_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API`)
};

/**
* | output |
* | --- |
* | "API" |
*
* @param {Pm_Source_ApiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_source_api = /** @type {((inputs?: Pm_Source_ApiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Source_ApiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_source_api(inputs)
	return cs_pm_source_api(inputs)
});